export const ADMIN_USERS = {
  page: 'admin-users-page',
  tabUsers: 'admin-users-tab',
  tabInvites: 'admin-invites-tab',
  tabActivity: 'admin-activity-tab',
  inviteBtn: 'admin-invite-open-btn',
  inviteDialog: 'admin-invite-dialog',
  inviteEmailInput: 'admin-invite-email-input',
  inviteNameInput: 'admin-invite-name-input',
  inviteRoleSelect: 'admin-invite-role-select',
  inviteSubmit: 'admin-invite-submit-btn',
  userRow: 'admin-user-row',
  toggleActiveBtn: 'admin-toggle-active-btn',
  deleteUserBtn: 'admin-delete-user-btn',
  inviteRow: 'admin-invite-row',
  resendInviteBtn: 'admin-resend-invite-btn',
  revokeInviteBtn: 'admin-revoke-invite-btn',
  deleteInviteBtn: 'admin-delete-invite-btn',
  activityRow: 'admin-activity-row',
  usersLink: 'admin-users-link',
  documentsLink: 'admin-documents-link',
};

export const INVITE = {
  page: 'accept-invite-page',
  passwordInput: 'accept-invite-password-input',
  nameInput: 'accept-invite-name-input',
  submitBtn: 'accept-invite-submit-btn',
  error: 'accept-invite-error',
};
